export const faqs = [
  {
    id: "faq-1",
    group: "选群入门",
    question: "51吃瓜群到底指的是什么？",
    answer:
      "「51吃瓜群」是网友对一类娱乐资讯讨论群的统称，核心特征是围绕娱乐圈动态、影视热点、网络新鲜事展开聊天，成员之间互相分享与讨论。它并不是某一个固定的群，而是方向类似的一大批群组的集合，因此不同群在氛围、更新频率和讨论深度上差异很大，需要根据自己的需求挑选。",
  },
  {
    id: "faq-2",
    group: "选群入门",
    question: "第一次进吃瓜群，应该选哪种类型？",
    answer:
      "建议先从一个「日更、新手友好、禁广告」的综合娱乐群开始。这类群更新稳定、话题面广，你能先感受整体氛围，再判断自己更偏好深度讨论还是轻松闲聊。不要一上来就加入十几个群，信息过载反而会让你很快退出。",
  },
  {
    id: "faq-3",
    group: "选群入门",
    question: "群人数越多就越好吗？",
    answer:
      "不一定。人数多代表热闹，但也意味着刷屏更快、噪音更大。真正影响体验的是「活跃人数」和「管理质量」：一个两千人但管理到位、话题聚焦的群，往往比五千人的大群更耐看。本站排行综合了活跃度、管理规范与成员口碑，而不是只看人数。",
  },
  {
    id: "faq-4",
    group: "活跃度判断",
    question: "怎么判断一个群是不是冷清群？",
    answer:
      "看三个信号：第一，工作日白天是否有持续对话，如果只有深夜零星几条，说明粘性不足；第二，热点发生后群里有没有人跟进整理，长期无响应基本可以判断为沉寂群；第三，管理员是否定期维护群规与话题。三项都不达标，就可以考虑退群换一个了。",
  },
  {
    id: "faq-5",
    group: "活跃度判断",
    question: "群里的「活跃度」数据是怎么来的？",
    answer:
      "活跃度综合了消息量、发言人数占比、话题持续时长和管理员在线频率四个维度，折算成 0 到 100 的分值。分值高说明这个群日常有人在聊、有人回应，而不是靠少数人刷屏撑起来的假热闹。",
  },
  {
    id: "faq-6",
    group: "避坑指南",
    question: "遇到收费入群、拉人头返利该怎么办？",
    answer:
      "正规的娱乐讨论群不会以任何名义收取入群费，也不会要求你拉人返利。凡是先交钱、先充值、承诺收益的，基本可以判定为营销或诈骗群，请直接退出并避免提供任何个人信息。本站推荐的群组均为免费交流性质。",
  },
  {
    id: "faq-7",
    group: "避坑指南",
    question: "群内有人发布未证实的「爆料」要注意什么？",
    answer:
      "把未经核实的内容一律当作「待证实」看待，不要转发到其他平台，也不要据此评价当事人。负责任的群会主动标注信息来源与可信度，遇到明显编造、涉及他人隐私的内容，请及时联系管理员处理。",
  },
  {
    id: "faq-8",
    group: "避坑指南",
    question: "为什么我进的群很快就被广告淹没了？",
    answer:
      "通常是群规执行不到位。挑选群组时可以优先关注那些明确写出「禁广告、禁刷屏」且有管理员日常巡查的群。另外，加入后建议关闭该群的免打扰之外，也可以主动向管理员反馈广告账号，好的群会很快处理。",
  },
  {
    id: "faq-9",
    group: "使用建议",
    question: "同时加入多个吃瓜群，怎么管理不被打扰？",
    answer:
      "建议保留两到三个：一个日更综合群用来跟热点，一个深度讨论群用来了解脉络，再加一个轻松向的群用来放松。其余群可以设置为免打扰或直接退出。数量控制在三个以内，信息质量和使用体验都会明显提升。",
  },
  {
    id: "faq-10",
    group: "使用建议",
    question: "本站的排行榜会更新吗？",
    answer:
      "排行榜会根据群组活跃度、成员反馈和管理情况定期复核调整。如果某个群长期沉寂、广告泛滥或氛围变差，它的排名会下降甚至移出推荐；表现稳定的群会持续保留在榜单前列。",
  },
];